<template>
<div class="kt-list-timeline__items">
    <slot></slot>
</div>
</template>

<script>
export default {

}
</script>

<style>

</style>